var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimitedLogo = function SvgLimitedLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "limitedLogo_svg__a",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h100v100H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#limitedLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 23a2.994 2.994 0 0 1 2.999 2.91l.001.077V51h17.947C71.633 51 73 52.343 73 54c0 1.63-1.324 2.957-2.973 2.999l-.08.001H49.053C47.367 57 46 55.657 46 54c0-.347.06-.681.17-.992a3 3 0 0 1-.169-.917L46 52.013V25.987A2.994 2.994 0 0 1 49 23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 50C7 26.252 26.252 7 50 7s43 19.252 43 43-19.252 43-43 43S7 73.748 7 50m80.788 0c0-20.87-16.918-37.788-37.788-37.788S12.212 29.13 12.212 50 29.13 87.788 50 87.788 87.788 70.87 87.788 50",
    clipRule: "evenodd"
  }))));
};
export default SvgLimitedLogo;